import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginModel } from '../../../model/login-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, SharedModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup;
  clientId: string | null = null;
  returnUrl: string | null = null;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) {
    this.clientId = this.authService.getClienteIdLocal();
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
      password: ['', [Validators.required, Validators.maxLength(128)]],
    });
  }



  login() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const clientId = this.authService.verificaClientId(this.clientId ?? '');
    if (clientId === null) {
      alert('Cliente invalido. Inicie o login pelo sistema que deseja acessar.');
      return;
    }

    if (!this.returnUrl) {
      alert('Contexto SSO invalido. Inicie o login pelo sistema que deseja acessar.');
      return;
    }

    this.spinner.show();
    const model: LoginModel = {
      email: this.loginForm.value.email.trim().toLowerCase(),
      password: this.loginForm.value.password,
      clientId,
      returnUrl: this.returnUrl,
    };

    this.authService.login(model).subscribe({
      next: (response) => {
        const redirectUrl = response.redirectUrl;
        if (redirectUrl && this.authService.isTrustedRedirect(redirectUrl)) {
          this.spinner.hide();
          window.location.assign(redirectUrl);
        } else {
          this.spinner.hide();
          console.error('URL de redirecionamento não encontrada');
        }
      },
      error: (error) => {
        alert("Erro ao realizar login");
        console.error(error);
        this.spinner.hide();
      },
    });
  }



}
